import { MetaReducer } from '@ngrx/store';
import { hydrationMetaReducer } from '@pa-store';

export const metaReducers: MetaReducer[] = [hydrationMetaReducer];
